export default __webpack_public_path__ + "static/media/Interactive Map.32afdf88.svg";